import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import { getScatterChartOptions } from "./utils";
import Labels from "./Labels";
import Legend from "./Legend";
import withTheme from "../../../hocs/withTheme";
import "./RiskReturnChart.css";

const initHighchartsMore = (HighchartsMore as any).default || HighchartsMore;
if (typeof initHighchartsMore === 'function') {
    initHighchartsMore(Highcharts);
}

function RiskReturnChart(props) {
    const {
        data = [],
        matrix = null,
        height = 400,
        minX = 0,
        maxX = 10,
        minY = 0,
        maxY = 20,
        xLabels = [],
        yLabels = [],
        tooltipFormat = (name, x, y) => `${name}: ${x}/${y}`,
    } = props;

    return (
        <div className="Risk-return-container">
            <div className="Risk-return-chart-container">
                <HighchartsReact
                    containerProps={{ className: "Highcharts-risk-return" }}
                    options={getScatterChartOptions(
                        data,
                        matrix,
                        height,
                        minX,
                        maxX,
                        minY,
                        maxY,
                        xLabels,
                        yLabels,
                        tooltipFormat
                    )}
                />
                <Labels xLabels={xLabels} yLabels={yLabels} />
            </div>
            <Legend data={data} matrix={matrix} />
        </div>
    );
}


export default withTheme(RiskReturnChart);
